import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { useAuth } from "@/hooks/useAuth";

export function useRestaurantBookmark(restaurantId: string) {
  const queryClient = useQueryClient();

  const toggleMutation = useMutation({
    mutationFn: async () => {
      const response = await apiRequest("POST", "/api/bookmarks/toggle", {
        restaurantId,
      });
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/api/user/bookmarks"] });
    },
  });

  return {
    toggleBookmark: toggleMutation.mutate,
    isToggling: toggleMutation.isPending,
  };
}

export function useUserBookmarks() {
  const { isAuthenticated } = useAuth();
  return useQuery<{ restaurantId: string; [key: string]: unknown }[]>({
    queryKey: ["/api/user/bookmarks"],
    enabled: isAuthenticated,
  });
}

export function useIsRestaurantBookmarked(restaurantId: string) {
  const { data: bookmarks } = useUserBookmarks();
  return bookmarks?.some((b) => b.restaurantId === restaurantId) ?? false;
}
